import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { storableError } from '../../util/errors';
import { getAllTransitionsForEveryProcess } from '../../transactions/transaction';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';

const sortedTransactions = txs =>
  reverse(
    sortBy(txs, tx => {
      return tx.attributes ? tx.attributes.lastTransitionedAt : null;
    })
  );

// ================ Action types ================ //
export const FETCH_ORDERS_REQUEST = 'app/OrdersPage/FETCH_ORDERS_REQUEST';
export const FETCH_ORDERS_SUCCESS = 'app/OrdersPage/FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_ERROR = 'app/OrdersPage/FETCH_ORDERS_ERROR';

// ================ Reducer ================ //
const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));

const initialState = {
  fetchInProgress: false,
  fetchOrdersError: null,
  pagination: null,
  transactionRefs: [],
};

export default function ordersPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ORDERS_REQUEST:
      return { ...state, fetchInProgress: true, fetchOrdersError: null };
    case FETCH_ORDERS_SUCCESS: {
      const transactions = sortedTransactions(payload.data.data);
      return {
        ...state,
        fetchInProgress: false,
        transactionRefs: entityRefs(transactions),
        pagination: payload.data.meta,
      };
    }
    case FETCH_ORDERS_ERROR:
      return { ...state, fetchInProgress: false, fetchOrdersError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //
const fetchOrdersRequest = () => ({ type: FETCH_ORDERS_REQUEST });
const fetchOrdersSuccess = response => ({
  type: FETCH_ORDERS_SUCCESS,
  payload: response,
});
const fetchOrdersError = e => ({
  type: FETCH_ORDERS_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //
const ORDERS_PAGE_SIZE = 50;

export const loadData = () => (dispatch, getState, sdk) => {
  dispatch(fetchOrdersRequest());

  // Determine if current user is a provider; providers should see their sales
  const state = getState();
  const currentUser = state?.user?.currentUser;
  const userType = currentUser?.attributes?.profile?.publicData?.userType;
  const isProvider = userType === 'provider';

  const apiQueryParams = {
    // For providers, fetch sales, for customers, fetch orders
    only: isProvider ? 'sale' : 'order',
    lastTransitions: getAllTransitionsForEveryProcess(),
    include: [
      'listing',
      'listing.images',
      'provider',
      'provider.profileImage',
      'customer',
      'customer.profileImage',
      'booking',
    ],
    'fields.transaction': [
      'processName',
      'lastTransition',
      'lastTransitionedAt',
      'transitions',
      'payinTotal',
      'payoutTotal',
      'lineItems',
      'protectedData',
    ],
    'fields.listing': ['title', 'availabilityPlan', 'publicData.listingType'],
    'fields.user': ['profile.displayName', 'profile.abbreviatedName', 'deleted', 'banned'],
    'fields.image': ['variants.square-small', 'variants.square-small2x'],
    page: 1,
    perPage: ORDERS_PAGE_SIZE,
  };

  return sdk.transactions
    .query(apiQueryParams)
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      dispatch(fetchOrdersSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchOrdersError(storableError(e)));
      throw e;
    });
};
